export function provisionLineKey(line) {
  return String(line || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

/** Case- and whitespace-insensitive dedupe; preserves first occurrence casing. */
export function dedupeProvisionLines(lines) {
  const seen = new Set();
  const out = [];
  for (const line of lines) {
    const trimmed = String(line || '').trim();
    if (!trimmed) continue;
    const key = provisionLineKey(trimmed);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}
